import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { Equation } from './equation';
/**
 * remarkMath会把公式解析为code标签，我们自己解析这个标签。
 */
export const MathExtension = Node.create({
  name: 'flowus-math',
  group: 'inline',
  inline: true,
  atom: true,
  priority: 2147483648,

  parseHTML() {
    return [
      {
        tag: 'code.language-math',
      },
    ];
  },
  addAttributes() {
    return {
      latex: {
        default: '',
        parseHTML: (element) => {
          return element.textContent;
        },
      },
      isInlineLatex: {
        default: false,
        parseHTML: (element) => {
          //由于无法解析成块公式，因此这里先用父的children判断，只有一个才是块
          // return element.classList.contains('math-inline');
          return (element.parentElement?.childNodes.length ?? 10) > 1;
        },
      },
    };
  },
  renderHTML({ node }) {
    return [
      'code',
      {
        class: `language-math ${node.attrs.isInlineLatex ? 'math-inline' : 'math-display'}`,
        'data-latex': node.attrs.latex,
      },
      0,
    ];
  },
  addNodeView() {
    return ReactNodeViewRenderer(Equation);
  },
});
